import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { className: "image shadow-md rounded-lg w-full min-w-80.45px h-full max-h-225px ms:h-225px overflow-hidden bg-black-background whitespace-nowrap" }
const _hoisted_2 = { className: "wrapper w-full h-full relative top-0 left-0 inline-block whitespace-nowrap" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", { class: "frame z-1 bg-clip-padding bg-frame-gradient bg-no-repeat bg-frame rounded-lg shadow-frame box-border block h-full left-0 overflow-hidden absolute right-0 top-0 whitespace-nowrap" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: '/anime/' + _ctx.anime.node.id + '/' + _ctx.anime.node.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", {
            className: "image inline-block w-full h-full whitespace-nowrap",
            title: _ctx.anime.node.title
          }, [
            _createElementVNode("img", {
              className: "poster inline-block w-full h-full min-h-125px min-w-80.45px outline-none border-none\n          bg-black-background",
              onError: "{addDefaultSrc}",
              src: _ctx.anime.node.main_picture.medium,
              alt: _ctx.anime.node.title
            }, null, 8, _hoisted_4),
            _hoisted_5
          ], 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}